import React from "react";
import { TableBody } from "@mui/material";
import { User, AccessTypeCode, StatusTypeCode, PinRegenerate, EnableUser, DisableUser, ReinviteUser } from "../../models/userModels";
import { ChipVariantMap, ChipLabelMap } from "../../../../shared/components/chips/ValueChip";
import { EmployeeRow } from "./EmployeeRow";

interface EmployeeTableBodyProps {
  users: User[];
  variantMap: ChipVariantMap<AccessTypeCode>;
  labelMap: ChipLabelMap<AccessTypeCode>;
  onReinviteUser: (data: ReinviteUser) => void;
  onDeleteUser: (id: string) => void;
  onChangeRole?: (user: User) => void;
  getTimeRemaining: (expirationDate?: Date) => { expired: boolean; text: string } | null;
  onPinRegenerate: (data: PinRegenerate) => void;
  onEnableTemporaryAccess: (data: EnableUser) => void;
  onDisableTemporaryAccess: (data: DisableUser) => void;
  getStatusLabel: (status: StatusTypeCode) => string;
  translate: (key: string, params?: any) => string;
  translateCommon: (key: string, params?: any) => string;
}

export const EmployeeTableBody: React.FC<EmployeeTableBodyProps> = ({
  users,
  variantMap,
  labelMap,
  onReinviteUser,
  onDeleteUser,
  onChangeRole,
  getTimeRemaining,
  onPinRegenerate,
  onEnableTemporaryAccess,
  onDisableTemporaryAccess,
  getStatusLabel,
  translate,
  translateCommon
}) => {
  return (
    <TableBody>
      {users.map((user) => (
        <EmployeeRow
          key={user.id}
          user={user}
          variantMap={variantMap}
          labelMap={labelMap}
          onReinviteUser={onReinviteUser}
          onDeleteUser={onDeleteUser}
          onChangeRole={onChangeRole}
          getTimeRemaining={getTimeRemaining}
          onPinRegenerate={onPinRegenerate}
          onEnableTemporaryAccess={onEnableTemporaryAccess}
          onDisableTemporaryAccess={onDisableTemporaryAccess}
          getStatusLabel={getStatusLabel}
          translate={translate}
          translateCommon={translateCommon}
        />
      ))}
    </TableBody>
  );
};
